<template>
    <div class="banner-background-area banner-background-area-bg bg-img section-space--ptb_120 bg-cover" :style="bgImg"  id="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="saas-banner-background">
                        <div class="content-wrapper">
                            <h2 class="heading_title text-white font-weight--light wow move-up">Simple Service è un prodotto di 64-bit</h2>
                            <div class="banner__text mt-20 text-white wow move-up">Un collettivo di professionisti IT </div>
                            <div class="banner__text mt-20 text-white wow move-up">Per maggiori info consulta il nostro sito <a class="btn btn--green" href="https://64-bit.it">64-bit.it</a> </div>
                            <img src="../assets/img/features/aeroland-contact-form-image-01.png" class="img-fluid" alt="64-bit" style="max-width:300px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BannerBgOne',
        data () {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/bg/aeroland-sass-image-04.jpg')})`
                },
            }
        }
    };
</script>
